import { render } from "./GEditTemplateSettingsModal.vue?vue&type=template&id=24d42e32&scoped=true"
import script from "./GEditTemplateSettingsModal.vue?vue&type=script&lang=js"
export * from "./GEditTemplateSettingsModal.vue?vue&type=script&lang=js"

import "./GEditTemplateSettingsModal.vue?vue&type=style&index=0&id=24d42e32&scoped=true&lang=less"
import "./GEditTemplateSettingsModal.vue?vue&type=style&index=1&id=24d42e32&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d42e32"]])

export default __exports__